import { Country } from 'modules/legal_entities/lib/constants'

import { FranceIdType } from './france/idType'
import { GermanyIdType } from './germany/idType'
import { ItalyIdType } from './italy/idType'
import { PortugalIdType } from './portugal/idType'
import { SpainIdType } from './spain/idType'

const getPlaceholderByCountryAndIdType = (
  country: Country,
  idType: SpainIdType | GermanyIdType | FranceIdType | ItalyIdType
) => {
  const placeholders: Record<Country, Record<string, string>> = {
    [Country.Spain]: {
      [SpainIdType.DNI]: '12345678A',
      [SpainIdType.NIE]: 'X12345678X',
      [SpainIdType.PASSPORT]: 'AAA123456',
      [SpainIdType.SOCIAL_SECURITY_NUMBER]: '111234567890',
    },
    [Country.France]: {
      [FranceIdType.NTT]: '',
      [FranceIdType.NIA]: '',
      [FranceIdType.PASSPORT]: 'AAA123456',
      [FranceIdType.NIR]: '178059933010817',
    },
    [Country.Germany]: {
      [GermanyIdType.Steueridentifikationsnummer]: '47036892816',
      [GermanyIdType.Reisepass]: 'AAA123456',
      [GermanyIdType.Sozialversicherungsnummer]: '52240282B806',
      [GermanyIdType.Personalausweis]: 'T220001293',
    },
    [Country.Italy]: {
      [ItalyIdType.CODICE_FISCALE]: 'RSSMRC74D22A001Q',
      [ItalyIdType.PERMESSO_DI_SOGGIORNO]: 'I12345678',
      [ItalyIdType.PASSPORT]: 'AAA123456',
      [ItalyIdType.CARTA_D_IDENTITA]: 'AA12345CC',
    },
    [Country.Portugal]: {
      [PortugalIdType.TaxId]: '501442600',
      [PortugalIdType.Passport]: 'P12345678',
      [PortugalIdType.SocialSecurityNumber]: '11111111128',
      [PortugalIdType.IdCard]: '12345678 9 AA 1',
      [PortugalIdType.ResidenceCard]: 'AB1234567',
    },
    // Add more countries and id_types below
  }

  const countryPlaceholders = placeholders[country]

  if (!countryPlaceholders || !countryPlaceholders[idType]) {
    return '' // Return an empty string if country or idType is not listed
  }

  return countryPlaceholders[idType]
}

export default getPlaceholderByCountryAndIdType
